import { render, staticRenderFns } from "./weight-chart.vue?vue&type=template&id=6df91eae&scoped=true&"
import script from "./weight-chart.vue?vue&type=script&lang=js&"
export * from "./weight-chart.vue?vue&type=script&lang=js&"
import style0 from "./weight-chart.vue?vue&type=style&index=0&id=6df91eae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df91eae",
  null
  
)

export default component.exports